import AccountTreeOutlined from '@mui/icons-material/AccountTreeOutlined';
import EProduct from '../products';
import routes from '../routes';
import { IProductConfig } from './Products.types';

const channelsConfig: IProductConfig = {
  baseUrlProd: routes.cmProd,
  baseUrlStaging: routes.cmStaging,
  baseUrlSandbox: routes.cmSandbox,
  icon: <AccountTreeOutlined />,
  modules: [
    {
      label: 'Profiles',
      path: '/profile',
      roles: ['CMAdmin', 'CMGuest'],
    },
    {
      label: 'Offers',
      path: '/offers',
      roles: ['CMAdmin', 'CMGuest'],
      customRoutes: [routes.cmOffersSandbox, routes.cmOffersStaging, routes.cmOffersProd],
    },
    {
      label: 'Allocation',
      path: '/allocation',
      customRoutes: [
        routes.cmAllocationSandbox,
        routes.cmAllocationStaging,
        routes.cmAllocationProd,
      ],
      roles: ['CMAdmin', 'CMGuest'],
    },
    {
      label: 'Client Price Manager',
      path: '/cpm',
      customRoutes: [routes.cmCPMSandbox, routes.cmCPMStaging, routes.cmCPMProd],
      roles: ['CMAdmin', 'CMGuest'],
    },
  ],
  product: EProduct.channels,
  popoverTitle: 'Channel Manager',
  title: 'Channels',
};

export default channelsConfig;
